import { render, staticRenderFns } from "./VegeIssueViewTable.vue?vue&type=template&id=5a0aa840&scoped=true"
import script from "./VegeIssueViewTable.vue?vue&type=script&lang=ts"
export * from "./VegeIssueViewTable.vue?vue&type=script&lang=ts"
import style0 from "./VegeIssueViewTable.vue?vue&type=style&index=0&id=5a0aa840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0aa840",
  null
  
)

export default component.exports